export default {"src":"/_next/static/media/noDeposit.57e25def.svg","height":130,"width":138};